export default __webpack_public_path__ + "static/dropdown-lang-bg-98af9475f2544013fe977d8208401014.png";